import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid2";
import { useContext } from "react";
import { FormContainer, useForm } from "react-hook-form-mui";
import UserProfileViewModel from "../Admin/User/ViewModels/UserProfileViewModel";
import { APIContext } from "../Contexts/APIContext";
import ReturnViewModel from "../Contexts/ReturnViewModel";
import RenderTextField from "../Utilities/Forms/RenderTextField";
import ChangePasswordViewModel from "./ViewModels/ChangePasswordViewModel";

interface IProps {
    user?: UserProfileViewModel;
    dialogOpen: boolean;
    handleClose: () => void;
}
export default function ChangePasswordDialog({ user, dialogOpen, handleClose, }: IProps) {
    const { post, showMessage } = useContext(APIContext);

    const formContextPassword = useForm<ChangePasswordViewModel>({
        defaultValues: new ChangePasswordViewModel(),
    });

    const updatePassword = (data: ChangePasswordViewModel) => {

        if (data.newPassword != data.newPasswordConf) {
            showMessage('error', "Passwords do not match ")
            return;
        }

        data.oldPassword = btoa(data.oldPassword)
        data.newPassword = btoa(data.newPassword)
        if (user?.id != null) {
            data.id = user.id;
            post('Auth', 'ChangePassword', data, async (response: ReturnViewModel) => {
                if (response)
                    showMessage('success', "Password successfully updated")
                formContextPassword.reset(new ChangePasswordViewModel());
            });
            handleCloseAndReset();
        }
    };

    const handleCloseAndReset = () => {
        formContextPassword.reset(new ChangePasswordViewModel());
        handleClose();
    };

    return (
        <Dialog open={dialogOpen} onClose={handleCloseAndReset} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Typography variant={"h6"}>Change Password</Typography>
            </DialogTitle>
            <FormContainer formContext={formContextPassword} onSuccess={updatePassword}>
                <DialogContent>

                    <Grid container alignItems="center" sx={{ mt: 2 }}>
                        <Grid size={12}>
                            <RenderTextField label="Old Passsword" name="oldPassword" readOnly={false} alwaysShow={true} type="password" labelSize={12} inputSize={12} required />
                        </Grid>
                        <Grid size={12}>
                            <RenderTextField label="New Passsword" name="newPassword" readOnly={false} alwaysShow={true} type="password" labelSize={12} inputSize={12} required />
                        </Grid>
                        <Grid size={12}>
                            <RenderTextField label="Confirm Passsword" name="newPasswordConf" readOnly={false} alwaysShow={true} type="password" labelSize={12} inputSize={12} required />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button fullWidth={false} onClick={handleCloseAndReset}>Cancel</Button>
                    <Button fullWidth={false} type="submit">Submit</Button>
                </DialogActions>
            </FormContainer>
        </Dialog >
    )
}